import React, { useEffect, useRef, useState } from "react";
import { Flex, ThemeInput, Divider, Skeleton } from "@fluentui/react-northstar";
import { V360ReportData } from "view360Card/models";
import { Monthly } from "./monthly/Monthly";
import { Cumulative } from "./cumulative/Cumulative";
import { ProductStructure } from "./productStructure/ProductStructure";
import { ClaimRatio } from "./claimRatio/ClaimRatio";
import styles from "./companyReportGroupView.module.scss";
import { Loader } from "ecom-teams-apps-core";
import pl from "shared/messages/pl";

export interface CompanyReportGroupProps {
    monthly?: V360ReportData;
    cumulative?: V360ReportData;
    productStructure?: V360ReportData;
    claimRatio?: V360ReportData;
    barTheme: ThemeInput;
    pieTheme: ThemeInput;
    loading: boolean;
    isMobileView: boolean;
}

const initialHight = 250;

export const CompanyReportGroupView: React.FC<CompanyReportGroupProps> = (props) => {
    const [boxHeight, setBoxHeight] = useState(initialHight);
    const boxRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!props.loading) {
            setBoxHeight(boxRef.current?.clientHeight ?? initialHight);
        }
    }, [props.loading]);

    const renderLoader = () => {
        return (
            <Flex fill hAlign="center" styles={{ marginTop: `${boxHeight / 3}px` }}>
                <Loader text={pl.view360Card.loadingReports} />
            </Flex>
        );
    };

    const renderContent = () => {
        return (
            <Flex column fill>
                <Flex className={styles.subgroup} gap="gap.small">
                    {props.monthly && (
                        <Flex.Item grow={5}>
                            <div>
                                {props.monthly && (
                                    <Flex fill>
                                        <Monthly report={props.monthly} theme={props.barTheme} />
                                        <Divider style={{ height: "100%" }} vertical />
                                    </Flex>
                                )}
                            </div>
                        </Flex.Item>
                    )}
                    <Flex.Item styles={{ minWidth: "40%" }}>
                        <div>
                            <Flex column>
                                <Divider
                                    className={styles.optionalDivider}
                                    style={{ paddingTop: "12px", paddingBottom: "12px" }}
                                />
                                {props.cumulative && <Cumulative report={props.cumulative} />}
                                {props.cumulative && props.productStructure && (
                                    <Divider style={{ paddingTop: "12px", paddingBottom: "12px" }} />
                                )}
                                {props.productStructure && (
                                    <ProductStructure
                                        report={props.productStructure}
                                        theme={props.pieTheme}
                                        isMobileView={props.isMobileView}
                                    />
                                )}
                            </Flex>
                        </div>
                    </Flex.Item>
                </Flex>
                {props.claimRatio && (
                    <Flex column fill>
                        <Divider style={{ paddingBottom: "12px" }} />
                        <ClaimRatio report={props.claimRatio} isMobileView={props.isMobileView} />
                    </Flex>
                )}
            </Flex>
        );
    };
    return (
        <Flex fill ref={boxRef} styles={{ height: props.loading ? `${boxHeight}px` : undefined }}>
            {props.loading ? renderLoader() : renderContent()}
        </Flex>
    );
};
